import { makeStateKey } from "@angular/platform-browser";

export const BASE_URI = makeStateKey<string>('BASE_URI');
export const BASE_URL = makeStateKey<string>('BASE_URL');
export const AT = makeStateKey<string>('AT');
